import React from 'react';
import { Plane, Train, Car, Hotel, MapPin, Info } from 'lucide-react';

const TravelPage = () => {
  const hotels = [
    {
      name: 'Le Meridien (Conference Venue)',
      category: '5 Star',
      distance: '0 km',
      rate: '₹6,000 - ₹10,000',
      contact: '+91 261 662 7777',
    },
    {
      name: 'The Gateway Hotel Athwalines',
      category: '5 Star',
      distance: '8 km from venue',
      rate: '₹5,000 - ₹8,000',
      contact: '+91 261 663 1234',
    },
    {
      name: 'Hotel Orange International',
      category: '4 Star',
      distance: '6 km from venue',
      rate: '₹3,500 - ₹5,500',
      contact: '+91 261 248 2222',
    },
    {
      name: 'Ginger Hotel Surat',
      category: '3 Star',
      distance: '5 km from venue',
      rate: '₹2,500 - ₹4,000',
      contact: '+91 261 668 3333',
    },
  ];

  return (
    <div className="min-h-screen pt-32 pb-16" data-testid="travel-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold mb-4" data-testid="travel-title">
            Travel & <span className="gradient-text">Stay</span>
          </h1>
          <p className="text-lg text-slate-300">
            Plan your trip to Surat, Gujarat
          </p>
        </div>

        <div className="glass-card p-8 md:p-12 mb-12" data-testid="venue-info">
          <div className="flex items-center gap-3 mb-6">
            <MapPin className="h-8 w-8 text-[#FF6F4A]" />
            <h2 className="text-3xl font-semibold">Conference Venue</h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">Le Meridien, Surat</h3>
              <p className="text-sm text-slate-400 mb-3">(Old The Grand Bhagwati)</p>
              <div className="space-y-3 text-slate-300">
                <p>
                  <strong className="text-white">Address:</strong><br />
                  Magdalla Circle, Dumas Road<br />
                  Surat, Gujarat 395007, India
                </p>
                <p>
                  <strong className="text-white">Website:</strong>{' '}
                  <a href="https://www.marriott.com/en-us/hotels/stvmd-le-meridien-surat" target="_blank" rel="noopener noreferrer" className="text-[#FF6F4A] hover:text-[#FFB6C1]">
                    www.marriott.com/le-meridien-surat
                  </a>
                </p>
                <div className="mt-4 glass-card p-4 border-[#FF6F4A]/30">
                  <p className="text-sm text-white font-semibold mb-2">Registration Queries:</p>
                  <p className="text-sm">Dr. Vrushal Bhansali: <a href="tel:+919173797939" className="text-[#FF6F4A]">9173797939</a></p>
                  <p className="text-sm">Dr. Kunjan Patel</p>
                  <p className="text-sm">Dr. Nikita Patel: <a href="tel:+919898587360" className="text-[#FF6F4A]">9898587360</a></p>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://customer-assets.emergentagent.com/job_agos2026/artifacts/ql8bu2dl_md-stvmd-exterior-27602_Pano-Hor.jpg"
                alt="Le Meridien Surat - Conference Venue"
                className="rounded-lg w-full h-auto glass-card"
              />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div className="glass-card p-8" data-testid="by-air">
            <div className="flex items-center gap-3 mb-6">
              <div className="glass-card p-3 neon-glow">
                <Plane className="h-6 w-6 text-[#FF6F4A]" />
              </div>
              <h2 className="text-2xl font-semibold">By Air</h2>
            </div>
            <div className="space-y-4 text-slate-300">
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">Surat Airport (STV)</h3>
                <p className="text-sm">Distance: 2.9 km from venue (~8 minutes)</p>
                <p className="text-sm">Travel Time: 20-30 minutes</p>
                <p className="text-sm mt-2">
                  Direct flights available from Delhi, Mumbai, Bangalore, and other major cities.
                </p>
              </div>
              <div className="border-t border-white/10 pt-4">
                <h3 className="text-lg font-semibold text-white mb-2">Nearest Major Airports</h3>
                <ul className="text-sm space-y-2">
                  <li><strong>Mumbai (BOM):</strong> 280 km, 4-5 hours by road</li>
                  <li><strong>Ahmedabad (AMD):</strong> 260 km, 4 hours by road</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="glass-card p-8" data-testid="by-train">
            <div className="flex items-center gap-3 mb-6">
              <div className="glass-card p-3 neon-glow">
                <Train className="h-6 w-6 text-[#FFB6C1]" />
              </div>
              <h2 className="text-2xl font-semibold">By Train</h2>
            </div>
            <div className="space-y-4 text-slate-300">
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">Surat Railway Station</h3>
                <p className="text-sm">Distance: 10 km from venue</p>
                <p className="text-sm">Travel Time: 20-25 minutes</p>
                <p className="text-sm mt-2">
                  Well connected to all major cities. Express trains available from Delhi, Mumbai,
                  Ahmedabad, Bangalore, and other metros.
                </p>
              </div>
              <div className="border-t border-white/10 pt-4">
                <h3 className="text-lg font-semibold text-white mb-2">Major Trains</h3>
                <ul className="text-sm space-y-1">
                  <li>• Shatabdi Express (from Mumbai)</li>
                  <li>• Rajdhani Express (from Delhi)</li>
                  <li>• Gujarat Mail</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="glass-card p-8 mb-12" data-testid="local-transport">
          <div className="flex items-center gap-3 mb-6">
            <div className="glass-card p-3 neon-glow">
              <Car className="h-6 w-6 text-[#FF6F4A]" />
            </div>
            <h2 className="text-2xl font-semibold">Local Transport</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-slate-300">
            <div>
              <h3 className="text-lg font-semibold text-white mb-3">Taxi Services</h3>
              <ul className="text-sm space-y-2">
                <li>• Uber & Ola available</li>
                <li>• Local taxi services</li>
                <li>• App-based cabs recommended</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white mb-3">Auto Rickshaws</h3>
              <ul className="text-sm space-y-2">
                <li>• Available throughout the city</li>
                <li>• Metered and prepaid options</li>
                <li>• Economical for short distances</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white mb-3">Car Rental</h3>
              <ul className="text-sm space-y-2">
                <li>• Self-drive and chauffeur options</li>
                <li>• Available at airport</li>
                <li>• Book in advance recommended</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="glass-card p-8 md:p-12" data-testid="accommodation">
          <div className="flex items-center gap-3 mb-6">
            <div className="glass-card p-3 neon-glow">
              <Hotel className="h-6 w-6 text-[#FFB6C1]" />
            </div>
            <h2 className="text-3xl font-semibold">Accommodation</h2>
          </div>
          <div className="mb-6">
            <div className="glass-card p-4 mb-4 inline-flex items-start gap-3">
              <Info className="h-5 w-5 text-[#FF6F4A] flex-shrink-0 mt-0.5" />
              <p className="text-sm text-slate-300">
                <strong className="text-white">Special Conference Rates:</strong> Mention &quot;AGOC 2026&quot;
                while booking to avail special discounted rates at partner hotels.
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {hotels.map((hotel, index) => (
              <div
                key={index}
                className="glass-card p-6 hover:scale-[1.02] transition-transform duration-300"
                data-testid={`hotel-${index}`}
              >
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h3 className="text-lg font-semibold mb-1">{hotel.name}</h3>
                    <span className="inline-block px-3 py-1 rounded-full text-xs bg-[#FF6F4A]/20 text-[#FF6F4A]">
                      {hotel.category}
                    </span>
                  </div>
                </div>
                <div className="space-y-2 text-sm text-slate-300">
                  <p>
                    <strong className="text-white">Distance:</strong> {hotel.distance}
                  </p>
                  <p>
                    <strong className="text-white">Rate:</strong> {hotel.rate} per night
                  </p>
                  <p>
                    <strong className="text-white">Contact:</strong> {hotel.contact}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 glass-card p-8 md:p-12" data-testid="food-section">
          <h2 className="text-3xl font-semibold mb-6 text-center">
            Famous <span className="gradient-text">Food Places</span> in Surat
          </h2>
          <p className="text-center text-slate-300 mb-8 max-w-3xl mx-auto">
            Surat is renowned for its vibrant street food culture and authentic Gujarati cuisine.
            Don&apos;t miss these iconic food spots during your visit!
          </p>

          <div className="mb-10">
            <h3 className="text-2xl font-semibold mb-6 flex items-center gap-2">
              <span className="text-[#FF6F4A]">⭐</span>
              Must-Try Street Food
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="glass-card p-6 hover:scale-[1.02] transition-transform duration-300">
                <h4 className="text-xl font-semibold mb-3 text-[#FF6F4A]">Gopal Locho Khaman House</h4>
                <p className="text-sm text-slate-300 mb-3">
                  <strong className="text-white">Specialty:</strong> Iconic for fluffy locho varieties (green garlic locho, tandoori cheese locho), khaman, idra, and paturi
                </p>
                <p className="text-sm text-slate-400 mb-2">
                  <strong>Location:</strong> Near Surat Station & City Light outlet
                </p>
                <p className="text-sm text-slate-400">
                  <strong>Famous for:</strong> &quot;Best locho in Surat&quot; with perfect spicy-sweet flavors
                </p>
              </div>

              <div className="glass-card p-6 hover:scale-[1.02] transition-transform duration-300">
                <h4 className="text-xl font-semibold mb-3 text-[#FFB6C1]">Jamnadas Ghari</h4>
                <p className="text-sm text-slate-300 mb-3">
                  <strong className="text-white">Specialty:</strong> Famous for Ghari, a rich Surati sweet pastry stuffed with nuts and spices
                </p>
                <p className="text-sm text-slate-400 mb-2">
                  <strong>Location:</strong> Multiple locations in Surat
                </p>
                <p className="text-sm text-slate-400">
                  <strong>Famous for:</strong> Authentic Surti ghari - a must-try dessert!
                </p>
              </div>

              <div className="glass-card p-6 hover:scale-[1.02] transition-transform duration-300">
                <h4 className="text-xl font-semibold mb-3 text-[#FF6F4A]">Jani Locho & Khaman House</h4>
                <p className="text-sm text-slate-300 mb-3">
                  <strong className="text-white">Specialty:</strong> Authentic locho and khaman with traditional Surti farsan
                </p>
                <p className="text-sm text-slate-400 mb-2">
                  <strong>Location:</strong> Central Surat
                </p>
                <p className="text-sm text-slate-400">
                  <strong>Famous for:</strong> Traditional Surti snacks and breakfast items
                </p>
              </div>

              <div className="glass-card p-6 hover:scale-[1.02] transition-transform duration-300">
                <h4 className="text-xl font-semibold mb-3 text-[#FFB6C1]">G Dada Farsan</h4>
                <p className="text-sm text-slate-300 mb-3">
                  <strong className="text-white">Specialty:</strong> Undhiyu (seasonal mixed vegetable curry) and various farsan
                </p>
                <p className="text-sm text-slate-400 mb-2">
                  <strong>Location:</strong> Surat City
                </p>
                <p className="text-sm text-slate-400">
                  <strong>Famous for:</strong> Winter special undhiyu, perfect with locho
                </p>
              </div>
            </div>
          </div>

          <div className="mb-10">
            <h3 className="text-2xl font-semibold mb-6 flex items-center gap-2">
              <span className="text-[#FF6F4A]">⭐</span>
              Authentic Gujarati Thali Restaurants
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="glass-card p-6 hover:scale-[1.02] transition-transform duration-300">
                <h4 className="text-xl font-semibold mb-3 text-[#FF6F4A]">Sasumaa Gujarati Thali</h4>
                <p className="text-sm text-slate-300 mb-3">
                  Authentic unlimited thalis since 1999. Celebrity favorite with traditional tin-plate service.
                </p>
                <p className="text-sm text-slate-400">
                  <strong>Serves:</strong> Rotis, sabzi, dal, kadhi, farsan, and sweets
                </p>
              </div>

              <div className="glass-card p-6 hover:scale-[1.02] transition-transform duration-300">
                <h4 className="text-xl font-semibold mb-3 text-[#FFB6C1]">Kansar Gujarati Thali</h4>
                <p className="text-sm text-slate-300 mb-3">
                  Top-rated for fluffy rotis, variety of sabzis, kadhi, and sweets. Staff in traditional attire.
                </p>
                <p className="text-sm text-slate-400">
                  <strong>Location:</strong> Central Surat
                </p>
              </div>

              <div className="glass-card p-6 hover:scale-[1.02] transition-transform duration-300">
                <h4 className="text-xl font-semibold mb-3 text-[#FF6F4A]">Jalaram Khichdi</h4>
                <p className="text-sm text-slate-300 mb-3">
                  168+ khichdi varieties with special spices. Signature Gujarati comfort food.
                </p>
                <p className="text-sm text-slate-400">
                  <strong>Famous for:</strong> Unique khichdi combinations
                </p>
              </div>
            </div>
          </div>

          <div className="glass-card p-6 bg-gradient-to-r from-[#FF6F4A]/10 to-[#FFB6C1]/10 border-[#FF6F4A]/30">
            <h3 className="text-xl font-semibold mb-4 flex items-center gap-2">
              <span className="text-2xl">🍴</span>
              Surati Food Guide
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-slate-300">
              <div>
                <p className="mb-2"><strong className="text-white">Best Time:</strong> Street food is best in mornings, thalis suit evenings</p>
                <p className="mb-2"><strong className="text-white">Must-Try Dishes:</strong></p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Locho - steamed savory snack</li>
                  <li>Khaman - fermented steamed cake</li>
                  <li>Ghari - sweet stuffed pastry</li>
                  <li>Undhiyu - mixed vegetable curry</li>
                </ul>
              </div>
              <div>
                <p className="mb-2"><strong className="text-white">Pro Tips:</strong></p>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Try different locho varieties - green garlic & tandoori cheese are favorites</li>
                  <li>Gujarati thalis offer unlimited servings</li>
                  <li>Most places are vegetarian</li>
                  <li>Street food near stations is authentic</li>
                  <li>Don&apos;t leave without trying ghari!</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 glass-card p-8 text-center" data-testid="travel-tips">
          <h2 className="text-2xl font-semibold mb-6">
            Travel <span className="gradient-text">Tips</span>
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-slate-300 text-sm">
            <div>
              <h3 className="text-lg font-semibold text-white mb-2">Best Time to Visit</h3>
              <p>October has pleasant weather in Surat. Temperature ranges from 22°C to 32°C.</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white mb-2">Currency</h3>
              <p>Indian Rupee (INR). ATMs and card payments widely available.</p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white mb-2">Local Cuisine</h3>
              <p>Don&apos;t miss Surati delicacies like Locho, Khaman, and Ghari!</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelPage;